<template>
<div class="main-cards card">
    <div class="card-header">
        <div class="headercard" style="display: flex; justify-content: space-between; align-items: center;">
            <img :src="require('@/assets/images/dashboard/grafico.png')" alt="home" style="max-width: 3vh;">
            &nbsp;
            <h5 style="margin: 0%">Histórico da Estação</h5>
            &nbsp;
            &nbsp;
            &nbsp;
            <div class="col-sm-3" style="flex-grow: 1; display: flex; justify-content: center;">
                <input class="form-control" type="date" v-model="inputDate">
                &nbsp;
                <button class="btn btn-success" type="button" @click="alterarData">Alterar data</button>
            </div>
        </div>
    </div>
    <div class="card-body" id="silos">
        <section>
            <canvas id="temperatureChart" height="300"></canvas>
        </section>
    </div>
</div>
</template>
<script>
import { ref } from 'vue';
import Chart from 'chart.js/auto';
import { useToast } from 'vue-toastification';
import { useStore } from "vuex";
import { useRoute } from 'vue-router';

export default {
    name: 'DashboardGraficoEstacao',
    props: {
        unidade: {
            type: Object,
            required: true
        }
    },

	setup(props, { emit }) {
		const store = useStore();
		const route = useRoute();
        const selectedDate = ref(new Date().toISOString().slice(0, 10));
		const inputDate = ref(selectedDate.value);
        const estacaoData = ref([]);
        const toast = useToast();


        const alterarData = async () => {
			const previousSelectedDate = selectedDate.value;
			try {
				selectedDate.value = inputDate.value;
				await fetchEstacaoData();
			} catch (error) {
				selectedDate.value = previousSelectedDate;
			}
		};

        const fetchEstacaoData = async () => {
			emit('update-loading', true);
			const unidadeId = route.params.unidade;

			const body = {
				unidadeId: unidadeId,
				dataInicio: selectedDate.value,
				dataFim: selectedDate.value
			};

			try {
				const response = await store.dispatch("estacao/fetchEstacaoDataRelatorio", body);
				if (!response.isAxiosError) {
					estacaoData.value = response.data;
					renderChart();
				}
			} catch (error) {
				if (error.isAxiosError) {
					window.chartInstance.destroy();
					toast.error('Não foi encontrado dados para a data selecionada', { timeout: 4000 });
				}
				console.log(error);
				throw error;
			} finally {
				emit('update-loading', false);
			}
		};

        const renderChart = () => {
			const canvas = document.getElementById('temperatureChart');
			if (!canvas) {
				console.warn('Canvas graficoEstacao não encontrado');
				return;
			}
			const ctx = canvas.getContext('2d');
			if (window.chartInstance) {
				window.chartInstance.destroy();
			}
			const labels = [];
			const temperatureData = [];
			const humidityData = [];
			const totalData = estacaoData.value.length;
			const interval = Math.ceil(totalData / 30);

			for (let i = 0; i < totalData; i++) {
				if (i % interval === 0 || i === totalData - 1) {
					const item = estacaoData.value[i];
					const itemDate = new Date(item.data);
					const hourLabel = `${itemDate.getHours() < 10 ? '0' + itemDate.getHours() : itemDate.getHours()}:${itemDate.getMinutes() < 10 ? '0' + itemDate.getMinutes() : itemDate.getMinutes()}`;

					labels.push(hourLabel);
					temperatureData.push(item.temperatura || 0);
					humidityData.push(item.umidade || 0);
				}
			}

			window.chartInstance = new Chart(ctx, {
				type: 'line',
				data: {
					labels: labels,
					datasets: [
						{
							label: 'Temperatura (°C)',
							data: temperatureData,
							borderColor: '#23d726',
							tension: 0.1,
							yAxisID: 'y1',
						},
						{
							label: 'Umidade (%)',
							data: humidityData,
							borderColor: '#1E90FF',
							yAxisID: 'y2',
						},
					]
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					scales: {
						x: {
							title: {
								display: true,
								text: 'Horário',
							},
							ticks: {
								autoSkip: false
							}
						},
						y1: {
							title: {
								display: true,
								text: 'Temperatura (°C)',
							},
							beginAtZero: false,
							ticks: {
								stepSize: 3,
								max: Math.max(...temperatureData) + 3,
								min: Math.min(...temperatureData) - 3,
							}
						},
						y2: {
							title: {
								display: true,
								text: 'Umidade (%)',
							},
							beginAtZero: true,
							ticks: {
								stepSize: 10,
								max: 100,
								min: 0,
							}
						},
					}
				}
			});
			window.chartInstance.resize();
		};

        return {
            inputDate,
            alterarData,
            fetchEstacaoData
        };
    }
}
</script>
<style scoped>
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.card-header .col-sm-3 {
    display: flex;
    justify-content: center;
    margin-left: auto;
}

.card-header img {
    max-width: 3vh;
}

.card-body {
    position: relative;
    padding-top: 20px;
}

input.form-control {
    width: auto;
}

.card {
    margin-bottom: 0;
}

.main-cards{
    margin: 0.5rem;
    margin-bottom: 1rem;
}
</style>